
import axios from 'axios';
import address from './address'
const API_URL = address+'/test';

//const API_URL = 'http://localhost:8080/intranet-nova/users';
//const loginURL = 'http://localhost:8080/intranet-nova/users/login';


class TestService {

    async saveResult(token, userResult, testDate){

        var postData = {
            rawResult: userResult,
            testDate: testDate
        };

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                'Authorization': token
                }
            };
            
        return axios.post(API_URL+"/save/result", JSON.stringify(postData), config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }


    async listResults(phoneNumber){

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                }
            };
            
        return axios.get(API_URL+"/list/results/"+phoneNumber, config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }


    async listTestKeys(testName){

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                }
            };
            
        return axios.get(API_URL+"/list/keys/"+testName, config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }

    async getTest(user, testId){

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                'Authorization': user.token
                }
            };
            
        return axios.get(API_URL+"/"+testId, config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }

    
    async listQuestions(user, parentId){

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                'Authorization': user.token
                }
            };
        return axios.get(API_URL+"/question/list/"+parentId, config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }


    async listQuestionChoices(user, questiontId){

        var config = {
            headers: {
                'Access-Control-Allow-Origin':'*',
                'Content-Type':'application/json;charset=UTF-8', 
                'Accept':'application/json;charset=UTF-8',
                'Authorization': user.token
                }
            };
        return axios.get(API_URL+"/question/choice/list/"+questiontId, config).then((response) => {
            return response.data;
        })
        .catch((e) => {
            throw e;
        })
    }

}

export default new TestService();